var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ToDoNotesIconSection'),_c('Body',{staticClass:"text-center"},[_vm._v(" "+_vm._s(_vm.basicDescription)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }